import { useState, useMemo, useEffect } from "react";
import { useTable, useGlobalFilter, useFilters, useSortBy } from "react-table";

import COLUMNS from "./columns";

import styles from "./ChecklistMonitor.module.css";
import { GlobalFilter } from "./Filters/GlobalFilter";
import {ChecklistServicesApi} from "../../service";
import { useHistory } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { useDispatch, useSelector } from "react-redux";
import { isSuperuserValue, isStandardUserValue } from "../../access/access";
import GenericModal from "../../UI/GenericModal";
import { set } from "date-fns/esm";
import Checkbox from "../../components/controls/Checkbox/Checkbox";
import ExportChecklistInExcelLogic from '../../components/fileExports/ExportExcel/exportChecklistInExcelLogic.js';


const draftSUButtons = ["View", "Edit", "Download", "Duplicate", "Delete", "Drivers Info"];
const toEvaluateSUButtons = ["View", "Evaluate", "Download", "Duplicate", "Delete", "Drivers Info"];
const workInProgressSUButtons = ["View", "Evaluate", "Download", "Duplicate", "Delete", "Drivers Info"];
const confirmedSUButtons = ["View", "Edit", "Download", "Duplicate", "Confirm", "Unconfirm", "Delete", "Drivers Info"];
const underReviewSUButtons = ["View", "Edit", "Download", "Delete", "Confirm", "Drivers Info"];
const evaluatedSUButtons = ["View", "Download", "Duplicate", "Unconfirm", "Delete", "Drivers Info"];

const toEvaluateCannotEvaluateSUButtons = ["View", "Download", "Duplicate", "Delete", "Drivers Info"];

const draftSTButtons = ["View", /*"Download",*/ /*"Duplicate"*/];
const toEvaluateSTButtons = ["View", "Evaluate", "Download", /*"Duplicate"*/];
const workInProgressSTButtons = ["View", "Evaluate", "Download", /*"Duplicate"*/];
const confirmedSTButtons = ["View", "Download", /*"Duplicate"*/];
const underReviewSTButtons = ["View", "Download"];
const evaluatedSTButtons = ["View", "Download", /*"Duplicate"*/];
const toEvaluateCannotEvaluateSTButtons = ["View", "Download",];

const frozenDraftSUButtons = ["View", "Download", "Drivers Info"];
const frozenNonDraftSUButtons = ["View", "Download", "Duplicate", "Drivers Info"];

const frozenDraftSTButtons = ["View", "Drivers Info"];
const frozenNonDraftSTButtons = ["View", "Download"];

// const frozenToEvaluateSUButtons = ["View", "Evaluate", "Download", "Duplicate", "Delete", "Drivers Info"];
// const frozenWorkInProgressSUButtons = ["View", "Evaluate", "Download", "Duplicate", "Delete", "Drivers Info"];
// const frozenConfirmedSUButtons = ["View", "Edit", "Download", "Duplicate", "Confirm", "Unconfirm", "Delete", "Drivers Info"];
// const frozenUnderReviewSUButtons = ["View", "Edit", "Download", "Delete", "Confirm", "Drivers Info"];
// const frozenEvaluatedSUButtons = ["View", "Download", "Duplicate", "Unconfirm", "Delete", "Drivers Info"];

// const frozenToEvaluateCannotEvaluateSUButtons = ["View", "Download", "Duplicate", "Delete", "Drivers Info"];

// const frozenDraftSTButtons = ["View", /*"Download",*/ /*"Duplicate"*/];
// const frozenToEvaluateSTButtons = ["View", "Evaluate", "Download", /*"Duplicate"*/];
// const frozenWorkInProgressSTButtons = ["View", "Evaluate", "Download", /*"Duplicate"*/];
// const frozenConfirmedSTButtons = ["View", "Download", /*"Duplicate"*/];
// const frozenUnderReviewSTButtons = ["View", "Download"];
// const frozenEvaluatedSTButtons = ["View", "Download", /*"Duplicate"*/];
// const frozenToEvaluateCannotEvaluateSTButtons = ["View", "Download",];


const checklistServicesApi = new ChecklistServicesApi();

const ChecklistMonitor = (props) => {
  const [showButtons, setShowButtons] = useState(false);
  // const [showInstructions, setShowInstructions] = useState(true);
  const [selectedRecordStatus, setSelectedRecordStatus] = useState("");
  const [selectedRecordId, setSelectedRecordId] = useState("");
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [componentRerenderedCounter, setComponentRerenderedCounter] = useState(0);
  const [selectedRecordParentCompany, setSelectedRecordParentCompany] = useState();
  const [selectedRecordSubsidiary, setSelectedRecordSubsidiary] = useState();
  const [selectedRecordCompany, setSelectedRecordCompany] = useState();
  const [selectedRecordControlFunction, setSelectedRecordControlFunction] = useState();
  const [selectedRecordIsFrozen, setSelectedRecordIsFrozen] = useState();
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showUnconfirmPopup, setShowUnconfirmPopup] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showDriversDetails, setShowDriversDetails] = useState(false);
  const [checklistDriversInfo, setChecklistDriversInfo] = useState();
  // const [driversDetailsButtonIsVisible, setDriversDetailsButtonIsVisible] = useState(false);
  // const [rowEnteredByMouse, setRowEnteredByMouse] = useState();
  const accountDetails = useSelector(state => state.accountDetails);
  const visibleOnBiFilterValue = useSelector(state => state['visible_on_bi_filter']);
  const [visibleDriversChecklistId, setVisibleDriversChecklistId] = useState(-1);
  const [error, setError] = useState();

  const { downloadChecklist } = ExportChecklistInExcelLogic();

  const dispatch = useDispatch();
  
  const [isSuperuser, setIsSuperuser] = useState(isSuperuserValue());
  const [isStandardUser, setIsStandardUser] = useState(isStandardUserValue());

  // GenericModal related state
  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();
  // the useTable hook recommends that you memoize the rows and columns using useMemo()
  // This ensures that the data isn't recreated in every render, which would result in recalculated logic every single time
  const tableColumns = useMemo(() => COLUMNS, []);

  console.log("render: start");
  // the call to useTable will return a table instance
  const {
    // these are functions and arrays that the useTable hook has given to us to enable easy table creation
    // we need to use all of these for it to work
    getTableProps, // it's a function that needs to be destructured on the table tag
    getTableBodyProps, // comment
    headerGroups, // contains the column heading information which belongs in the thead tag of the table
    rows, // comment
    columns,
    prepareRow, // comment
    state,
    setGlobalFilter,

  } = useTable(
    {
      columns: tableColumns,
      data: tableData, // tableData
      initialState: {
        sortBy: [
          {
            id: 'id',
            desc: true
          }
        ],
        hiddenColumns: [!isSuperuser ? "visible_on_bi" : ""]
      },
      // autoResetGlobalFilter: false,
      // autoResetPage: false,
    }, 
    useFilters,
    useGlobalFilter,
    useSortBy
  );

  const {globalFilter } = state;

  useEffect(() => {
    let mounted = true;
    document.addEventListener("keydown", escFunction, false);
    setIsLoading(true);

    setIsSuperuser(isSuperuserValue());
    setIsStandardUser(isStandardUserValue());

    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.getChecklistMonitor((error, checklistMonitorData) => {
      if (mounted) {
        if (!error) {
          console.log("Checklist monitor", checklistMonitorData);
          console.log("Checklist Monitor columns: ", tableColumns);
          const tData = checklistMonitorData.map((item) => {
            // let toEvaluateAt = item.toEvaluateAt ? item.toEvaluateAt.toLocaleDateString('en-GB') : "TBD"
            let clState = "";
            if (isSuperuserValue() && item.frozen && item.checklistState && item.checklistState.name === "Evaluated") {
              clState = "Frozen";
            } else {
              clState = item.checklistState ? item.checklistState.name : "";
            }
            return {
              id: item.id,
              name: item.name,
              // status: item.checklistState ? item.checklistState.name : "",
              status: clState,
              fiscal_year: item.fiscalYear,
              period: item.checklistPeriod ? item.checklistPeriod.name : "-",
              creation_date: item.toEvaluateAt ? item.toEvaluateAt.toISOString() : "TBD",
              evaluation_date: item.evaluatedAt ? item.evaluatedAt.toISOString() : "Pending...",
              user: item.lastModifiedBy ? (item.lastModifiedBy.displayName ? item.lastModifiedBy.displayName : item.lastModifiedBy.id) : "N/A",
              parent_company: item.legalEntityParentCompany ? item.legalEntityParentCompany.name : "",
              subsidiary: item.legalEntitySubsidiary ? item.legalEntitySubsidiary.name : "-",
              region: item.legalEntityRegion ? item.legalEntityRegion.name : "-",
              company: item.legalEntityCompany ? item.legalEntityCompany.name : "-",
              supervised_entity: item.supervisedEntity,
              qualitative_evaluation_only: item.qualitativeOnly,
              control_function: item.controlFunction ? item.controlFunction.name : "-",
              visible_on_bi: item.visibleOnBI,
              frozen: item.frozen
              // frozen: item.frozen ? item.frozen : true
            }
          })
        
          setTableData(tData);
          setIsLoading(false);
          if (componentRerenderedCounter > 0) {
            // setShowButtons(true);
          }
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }
    })
    return () => {
      document.removeEventListener("keydown", escFunction, false);
      mounted = false;
    }
    
  },[componentRerenderedCounter]);

  console.log("tableData: ", tableData)
  const rerenderComponent = () => {
    setComponentRerenderedCounter(componentRerenderedCounter + 1);
  }

  // FUNCTIONS: START
  
  const escFunction = (event) => {
    if(event.keyCode === 27) {
      setShowDuplicatePopup(false);
      setShowDeletePopup(false);
      setShowUnconfirmPopup(false);
      setShowConfirmPopup(false);
      setShowDriversDetails(false);
    }
  }

  const showButtonsHandler = (cells, row) => {
    console.log("showButtonsHandler row: ", row)
    // let id = cells[0].value;
    let id = cells.filter(cell => cell.column.id === "id")[0].value;
    // let status = cells[2].value;
    let status = cells.filter(cell => cell.column.id === "status")[0].value;
    // let parentCompany =  cells[7].value;
    let parentCompany =  cells.filter(cell => cell.column.id === "parent_company")[0].value;
    // let subsidiary =  cells[8].value;
    let subsidiary =  cells.filter(cell => cell.column.id === "subsidiary")[0].value;
    // let company =  cells[10].value;
    let company =  cells.filter(cell => cell.column.id === "company")[0].value;

    let controlFunction =  cells.filter(cell => cell.column.id === "control_function")[0].value;

    let frozen =  row.original.frozen;

    setShowDuplicatePopup(false);
    setShowDeletePopup(false);
    setShowUnconfirmPopup(false);
    setShowConfirmPopup(false);
    setShowButtons(true);
    setSelectedRecordId(id);
    setSelectedRecordStatus(status);
    setSelectedRecordParentCompany(parentCompany);
    setSelectedRecordSubsidiary(subsidiary);
    setSelectedRecordCompany(company);
    setSelectedRecordControlFunction(controlFunction);
    setSelectedRecordIsFrozen(frozen);
    // console.log("id", id)
    // console.log("status", status)
    // console.log("parentCompany", parentCompany)
    // console.log("subsidiary", subsidiary)
    // console.log("company", company)
  };
  
  const actionButtonClicked = (action) => {
    let id = selectedRecordId;
    console.log("API request: " + action);
    console.log("recordStatus: ", selectedRecordStatus);
    console.log("recordId: ", selectedRecordId);

    const checklistServicesApi = new ChecklistServicesApi();
    switch (action) {
      case 'View':
        history.push("/view-checklist?checklistId="+id);
        break;
      case 'Edit':
        if (isSuperuser && selectedRecordStatus === "Draft") {
          history.push('/edit-new-checklist?checklistId='+id)
        }
        if(selectedRecordStatus === "Confirmed" || selectedRecordStatus === "Under Review") {
          history.push("/edit-evaluated-checklist?checklistId="+id);
        } 
        // else {
        //   history.push("/edit-checklist?checklistId="+id);
        // }
        break;
      case 'Evaluate':
        history.push("/evaluate-checklist?checklistId="+id);
        break;
      case 'Duplicate':
        setShowDuplicatePopup(true);
        break;
      case 'Delete':
        setShowDeletePopup(true);
        break;
      case 'Confirm':
        setShowConfirmPopup(true);
        // genericModalDataHandler("Confirm Checklist", "Confirm checklist?", 'confirmation', () => confirmChecklistHandler(id));
        break;
      case 'Unconfirm':
        setShowUnconfirmPopup(true);
        break;
      case 'Download':
        downloadChecklistHandler(id);
        break;
      case 'Drivers Info':
        getChecklistDriversHandler(id);
        break;
      default:
        break;
    }
  }

  const isInsideEvaluationScopeHandler = () => {
    const authorities = accountDetails.authorities;
    let isParentCompany;
    let isSubsidiary;
    let isCompany;
    let isControlFunction;
    for (const el of authorities) {
      isParentCompany = false;
      isSubsidiary = false; 
      isCompany = false;
      isControlFunction = false;
      if (el.type === "ST") {
        if (el.legalEntityParentCompany === undefined || (el.legalEntityParentCompany && (el.legalEntityParentCompany.name === selectedRecordParentCompany))) {
          isParentCompany = true;
        }
        if (el.legalEntitySubsidiary === undefined || (el.legalEntitySubsidiary && (el.legalEntitySubsidiary.name === selectedRecordSubsidiary))) {
          isSubsidiary = true;
        }
        if (el.legalEntityCompany === undefined || (el.legalEntityCompany && (el.legalEntityCompany.name === selectedRecordCompany))) {
          isCompany = true;
        }
        if ( (el.controlFunction === undefined) || (el.controlFunction && ((el.controlFunction.name !== "None") && (el.controlFunction.name === selectedRecordControlFunction))) ) {
          isControlFunction = true;
        }

        // console.log(
        //   "selectedRecordParentCompany, selectedRecordSubsidiary, selectedRecordCompany, ",
        //   selectedRecordParentCompany,
        //   selectedRecordSubsidiary,
        //   selectedRecordCompany
        // );
        // console.log("isParentCompany, isSubsidiary, isCompany, isControlFunction: ", isParentCompany, isSubsidiary, isCompany, isControlFunction);
        if (isParentCompany && isSubsidiary && isCompany && isControlFunction) {
          return true;
        }
      }
    }
    return false;
  }

  const duplicateButtonAnswerHandler = (checklistId, includeAnswers) => {
    setIsLoading(true);
    setShowDuplicatePopup(false);
    setShowButtons(false);
    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.duplicateChecklist(checklistId, includeAnswers, (error, data) => {
      if (!error) {
        // setIsLoading(false);
        console.log("Duplicate Checklist response: ", data, error);
        genericModalDataHandler("", `The checklist with id ${checklistId} was duplicated! \nCopy id: ${data.id}`, 'notification');
        // setShowButtons(true);
        rerenderComponent();
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    })
  }

  const deleteButtonAnswerHandler = (checklistId) => {
    setIsLoading(true);
    setShowDeletePopup(false);
    setShowButtons(false);
    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.deleteChecklist(checklistId, (error, data) => {
      if (!error) {
        console.log("Delete Checklist response: ", data, error);
        // setIsLoading(false);
        genericModalDataHandler("", `The checklist with id ${checklistId} was deleted!`, 'notification');
        rerenderComponent();
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    })
  }

  const unconfirmButtonAnswerHandler = (checklistId) => {
    setIsLoading(true);
    setShowUnconfirmPopup(false);
    setShowButtons(false);
    const checklistServicesApi = new ChecklistServicesApi();

    checklistServicesApi.unconfirm(checklistId, (error, data) => {
      if (!error) {
        console.log("Unconfirm Checklist response: ", data, error);
        // setIsLoading(false);
        genericModalDataHandler("", `The checklist with id ${checklistId} was set to Work in Progress status!`, 'notification');
        setSelectedRecordStatus("WIP");
        rerenderComponent();
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    })
  }

  const confirmButtonAnswerHandler = (checklistId) => {
    setIsLoading(true);
    setShowConfirmPopup(false)
    setShowButtons(false);
    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.evaluated(checklistId, (error, data) => {
      if (!error) {
        console.log("Evaluated response : ", data);
        // setIsLoading(false);
        genericModalDataHandler("", `The checklist with id ${checklistId} is now Evaluated!`, 'notification');
        setSelectedRecordStatus("Evaluated");
        rerenderComponent();
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
        // setIsLoading(false);
        // genericModalDataHandler("", "Error! The checklist was not confirmed!", 'error', () => setModalShow(false));
      }
    })
  }

  const updateVisibleOnBiHandler = (chklId, updatedVisibility, column) => {
    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.toggleChecklistVisibilityOnBI(chklId, updatedVisibility, (error, data) => {
      if (!error) {
        console.log("toggleChecklistVisibilityOnBI response: ", data, error);
        const newTableData = [...tableData];
        newTableData.filter(el => el.id === chklId)[0].visible_on_bi = updatedVisibility;
        setTableData(newTableData);
        column.setFilter(visibleOnBiFilterValue)
        setIsLoading(false);
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    })
  }

  const downloadChecklistHandler = (checklistId) => {
    const checklistServicesApi = new ChecklistServicesApi();
    
    checklistServicesApi.getChecklistById(checklistId, (error, checklistInfo) => { 
      if (!error) {
        const qualitativeAnswers = checklistInfo.checklistQualitativeAnswerTypes
        .sort((a, b) => a.id > b.id ? 1 : -1)
        .map(el => {
          return {
            answer: el.answer
          }
        });
        console.log("qualitativeAnswers: ", qualitativeAnswers)
        const checklistName = checklistInfo.name;
        console.log("checklist info: ", checklistInfo);
        
        checklistServicesApi.getChecklistCosoHierarchyById(checklistId, (error, checklistData) => { 
            if (!error) {
              const fattoriQualificanti = checklistData;
              console.log("fattoriQualificanti: ", fattoriQualificanti);
              const {mainData, opScopes} = initialConfiguration(fattoriQualificanti); // mainData is the checklist data flattened
              downloadChecklist(checklistName, mainData, opScopes, qualitativeAnswers);
              // setIsLoading(false);
          } else {
            setError(() => {
              throw new Error ("");
              // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
            })
          }
        });
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }  
    });
  }

  const initialConfiguration = (fattoriQualificanti) => {
    const initialOpScopes = [];

    // creating the initialOpScopes array
    let opScopesArrayCreated = false;
    for (let fatQual of fattoriQualificanti) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        for (let requisito of principio.checklistCosoRequisiti) {
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions && ambito.checklistQualitativeQuestions.length > 0) { // only needed if I receive ambiti with no questions
              for (let question of ambito.checklistQualitativeQuestions) {
                for (let opScope of question.checklistQualitativeQuestionOperationalScopes) {
                  const tempOS = {
                    id: opScope.operationalScope.id,
                    name: opScope.operationalScope.name,
                    tooltip: opScope.operationalScope.tooltip,
                    infoIconIsVisible: false
                  }
                  initialOpScopes.push(tempOS);
                }
                opScopesArrayCreated = true;
                break;
              }
            }
            if (opScopesArrayCreated) break;
          }
          if (opScopesArrayCreated) break;
        }
        if (opScopesArrayCreated) break;
      }
      if (opScopesArrayCreated) break;
    }

    initialOpScopes.sort((a, b) => a.id > b.id ? 1 : -1);
    console.log("sorted opScopes: ", initialOpScopes);
  
    // SORTING ALL THE ARRAYS
    fattoriQualificanti.sort((a, b) => a.position > b.position ? 1 : -1);
    for (let fatQual of fattoriQualificanti) {
      fatQual.checklistCosoPrincipi.sort((a, b) => a.position > b.position ? 1 : -1);
      for (let principio of fatQual.checklistCosoPrincipi) {
        principio.checklistCosoRequisiti.sort((a, b) => a.position > b.position ? 1 : -1);
        for (let requisito of principio.checklistCosoRequisiti) {
          requisito.checklistCosoAmbiti.sort((a, b) => a.position > b.position ? 1 : -1);
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              ambito.checklistQualitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
            } else {
              ambito.checklistQuantitativeDrivers.sort((a, b) => a.position > b.position ? 1 : -1);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                checklistQuantitativeDriver.checklistQuantitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
              }
            }
          }
        }
      }
    }
    console.log("sortedData: ", fattoriQualificanti);
  
    let mainData = [];
    for (let fatQual of fattoriQualificanti) {
      mainData.push(createDataObject(fatQual, "fatQual")); // id, position(?probably not needed) title, type, operationalScopes values
      for (let principio of fatQual.checklistCosoPrincipi) {
        mainData.push(createDataObject(principio, "principio"));
        for (let requisito of principio.checklistCosoRequisiti) {
          mainData.push(createDataObject(requisito, "requisito"));
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              mainData.push(createDataObject(ambito, "ambito"));
              for (let question of ambito.checklistQualitativeQuestions) {
                mainData.push(
                  createQuestionObject(
                    question,
                    question.checklistQualitativeQuestionOperationalScopes, 
                    fatQual.id,
                    principio.id,
                    requisito.id,
                    ambito.id,
                    initialOpScopes,
                    "qualitative"
                )); 
              }
            } else {
            // if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              mainData.push(createDataObject(ambito, "ambito"));
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                for (let question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                  mainData.push(
                    createQuestionObject(
                      question,
                      question.checklistQuantitativeQuestionOperationalScopes, 
                      fatQual.id,
                      principio.id,
                      requisito.id,
                      ambito.id,
                      initialOpScopes,
                      "quantitative"
                  )); 
                }
              }
            }
          }
        }
      }
    }
  
    // fatQual "span" property will determine the number of rows that this title will occupy
    let count = 0;
    for (let i = mainData.length - 1; i >= 0; i--) {
      const arrayEl = mainData[i];
        // length of each fattore qualificante
        if(arrayEl.type && arrayEl.type === "fatQual") {
          arrayEl.span = count;
          // Object.defineProperty(arrayEl, "span", { value: count });
          count = 0;
        } else {
          count++;
        }
    }

    return {mainData, opScopes: initialOpScopes};    
  }

  const createDataObject = ({id, title, tooltip, position}, givenType) => {

    return {
      id,
      title,
      tooltip,
      type: givenType,
      isHidden: false,
      isCollapsed: false,
      ...(givenType === "principio" && {position})
    };
  }

  const createQuestionObject = (
    {
      position,
      question: title,
      id: questionId,
      tooltip,
      displayId,
      note
    },
    opScopesObjects,
    fatQualId,
    principioId,
    requisitoId,
    ambitoId,
    operationalScopes,
    questionType,
  ) => {
    // transform the opScopes information
    const tempOpScopes = [];
    for (let opScope of operationalScopes) {
      for (let opScopesObject of opScopesObjects) {
        if (opScopesObject.operationalScope.name === opScope.name) {
          let opScopeName = opScopesObject.operationalScope.name;
          let opScopeAnswer;
          if (questionType === "qualitative") {
            opScopeAnswer = opScopesObject.checklistQualitativeAnswerType ? opScopesObject.checklistQualitativeAnswerType.answer : null
          } else {
            if (opScopesObject.answer === null) {
              opScopeAnswer = "N/A";
            } else if (opScopesObject.answer === -9999) { // unanswered field
              opScopeAnswer = "";
            } else {
              opScopeAnswer = opScopesObject.answer;
            }
          }
          let opScopeEnabled = opScopesObject.enabled;
          tempOpScopes.push({name: opScopeName, answer: opScopeAnswer, enabled: opScopeEnabled});
          break;
        }
      }
    }
    
    return {
      operationalScopes: tempOpScopes,
      position,
      title,
      tooltip,
      displayId,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      questionId,
      questionType, // qualitative, quantitative
      note,
      isHidden: false
    };
  };

  // modal of Delete, Duplicate and Unconfirm buttons
  const closeModalHandler = () => {
    console.log('close modal handler');
    setShowDuplicatePopup(false);
    setShowDeletePopup(false);
    setShowUnconfirmPopup(false);
    setShowConfirmPopup(false);
    setShowDriversDetails(false);
  }

  // handler of GenericModal component
  const genericModalDataHandler = (title, message, modType, action) => {
    console.log('title ', title)
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const genericModalCloseHandler = () => {
    setModalShow(false);
  }

  const clearGlobarFiltersHandler = () => {
    dispatch({ type: 'resetChecklistMonitorFilters' });
    console.log("columns: ", columns);
    for (let column of columns) {
      if (column.Filter /* && column.Filter.name === "SelectFilter" */) {
        console.log("filter name: ", column.Filter.name)
        column.setFilter("")
      }
    }
  }
  
  // const showDriversDetailsButton = (e, rowId) => {
  //   e.preventDefault();
  //   setDriversDetailsButtonIsVisible(true);
  //   setRowEnteredByMouse(rowId)
  //   console.log("ROWID: ", rowId)
  // };
  
  // const hideDriversDetailsButton = (e, rowId) => {
  //   e.preventDefault();
  //   setDriversDetailsButtonIsVisible(false);
  // };

  const getChecklistDriversHandler = (id) => {
    if (isSuperuserValue() === true) {
      setVisibleDriversChecklistId(id);
      checklistServicesApi.getChecklistById(id, (error, checklistInfo) => {
        // if (mounted) { // making sure that the component is still mounted before updating any state
        if (!error) {
            checklistInfo.checklistTemplateQuantitativeDrivers.sort((a,b) => a.templateQuantitativeDriver.position > b.templateQuantitativeDriver.position ? 1 : -1)
            console.log(`Checklist with id ${id} info retrieved: `, checklistInfo);
            setChecklistDriversInfo(checklistInfo)
            setShowDriversDetails(true);
          } else {
            setError(() => {
              throw new Error ("");
            })
          }
        // }
      })
    }
  }

  // FUNCTIONS: END

  let buttons = <div className={`d-flex flex-row justify-content-end align-items-center`}></div>;

  if(showButtons) {
    let actions = draftSUButtons;

    if (isSuperuser) {
      if (!selectedRecordIsFrozen) {
        switch(selectedRecordStatus) {
          case "Draft":
            actions = draftSUButtons;
            break;
          case "To Evaluate":
            if (isStandardUser) {
              if (isInsideEvaluationScopeHandler()) {
                actions = toEvaluateSUButtons;
              } else {
                actions = toEvaluateCannotEvaluateSUButtons;
              }
            } else {
              actions = toEvaluateCannotEvaluateSUButtons;
            }
            break;
          case "WIP":
            if (isStandardUser) {
              if (isInsideEvaluationScopeHandler()) {
                actions = workInProgressSUButtons;
              } else {
                actions = toEvaluateCannotEvaluateSUButtons;
              }
            } else {
              actions = toEvaluateCannotEvaluateSUButtons;
            }
            break;
          case "Confirmed":
              actions = confirmedSUButtons;
            break;
          case "Under Review":
            actions = underReviewSUButtons;
            break;
          case "Evaluated":
            actions = evaluatedSUButtons;
            break;
          default:
            break;
        }
      } else {
        if (selectedRecordStatus === "Draft") {
          actions = frozenDraftSUButtons;
        } else {
          actions = frozenNonDraftSUButtons;
        }
      }
      
    } else { // for standard users
      if (!selectedRecordIsFrozen) {
        switch(selectedRecordStatus) {
          case "Draft":
            actions = draftSTButtons;
            break;
          case "To Evaluate":
            if (isInsideEvaluationScopeHandler()) {
              actions = toEvaluateSTButtons;
            } else {
              actions = toEvaluateCannotEvaluateSTButtons;
            }
            break;
          case "WIP":
            if (isInsideEvaluationScopeHandler()) {
              actions = workInProgressSTButtons;
            } else {
              actions = toEvaluateCannotEvaluateSTButtons;
            }
            break;
          case "Confirmed":
            actions = confirmedSTButtons;
            break;
          case "Under Review":
            actions = underReviewSTButtons;
            break;
          case "Evaluated":
            actions = evaluatedSTButtons;
            break;
          default:
            break;
        }
      } else {
          if (selectedRecordStatus === "Draft") {
            actions = frozenDraftSTButtons;
          } else {
            actions = frozenNonDraftSTButtons;
          }
        }
    }

    const duplicatePopup = showDuplicatePopup && 
    <div className={`${styles.popup} ${styles.duplicatePopup}`}>
      <p align="center" className="mb-2">Duplication of checklist with id {selectedRecordId}</p>
      <p align="center" className="mb-2 fw-normal">Would you like to keep the checklist answers in the duplicated version?</p>
      <div className="d-flex justify-content-center">
        <button className={`${styles.popupButtons} ${styles.duplicatePopupButton} me-4`} onClick={() => duplicateButtonAnswerHandler(selectedRecordId, true)}>Yes</button>
        <button className={`${styles.popupButtons} ${styles.duplicatePopupButton}`} onClick={() => duplicateButtonAnswerHandler(selectedRecordId, false)}>No</button>
      </div>
    </div>

    const deletePopup = showDeletePopup && 
    <div className={`${styles.popup} ${styles.deletePopup}`}>
      <p align="center" className="mb-2">Delete checklist?</p>
      <p align="center" className="mb-2 fw-normal">By clicking "Yes" the checklist with id {selectedRecordId} will be removed permanently!</p>
      <div className="d-flex justify-content-center">
        <button className={`${styles.popupButtons} ${styles.deletePopupButton} me-4`} onClick={() => deleteButtonAnswerHandler(selectedRecordId)}>Yes</button>
        <button className={`${styles.popupButtons} ${styles.deletePopupButton}`} onClick={closeModalHandler}>No</button>
      </div>
    </div>

    const unconfirmPopup = showUnconfirmPopup && 
    <div className={`${styles.popup} ${styles.unconfirmPopup}`}>
      <p align="center" className="mb-2 fw-bold">Unconfirm checklist with id {selectedRecordId}?</p>
      <p align="center" className="mb-2 fw-normal">By clicking "YES" the checklist will return to Work in Progress status and will need a new confirmation from the control function.</p>
      <div className="d-flex justify-content-center">
        <button className={`${styles.popupButtons} ${styles.unconfirmPopupButton} me-4`} onClick={() => unconfirmButtonAnswerHandler(selectedRecordId)}>Yes</button>
        <button className={`${styles.popupButtons} ${styles.unconfirmPopupButton}`} onClick={closeModalHandler}>No</button>
      </div>
    </div>

    const confirmPopup = showConfirmPopup && 
    <div className={`${styles.popup} ${styles.confirmPopup} d-flex flex-column justify-content between`}>
      <p align="center" className="fw-bold">Confirm checklist with id {selectedRecordId}?</p>
      <p align="center" className="fw-normal">By clicking "YES" the checklist status will be set to "Evaluated".</p>
      <div className="d-flex justify-content-center">
        <button className={`${styles.popupButtons} ${styles.confirmPopupButton} me-4`} onClick={() => confirmButtonAnswerHandler(selectedRecordId)}>Yes</button>
        <button className={`${styles.popupButtons} ${styles.confirmPopupButton}`} onClick={closeModalHandler}>No</button>
      </div>
    </div>

    buttons = <div className={` d-flex flex-row justify-content-end align-items-center`}>
      <div className={`${styles.backdrop} ${showDuplicatePopup || showDeletePopup || showUnconfirmPopup || showConfirmPopup || showDriversDetails ? "visible" : "invisible"}`} 
        onClick={closeModalHandler}>
      </div>
        {/* {console.log("actions: ", actions)} */}
        {actions.map( (action, index) => {
          let modifiedActionName = action.replace(/\s/g, '');
          return <div key={action + "-" + index} 
          disabled={isLoading} 
          className={`${styles[modifiedActionName]} position-relative`} 
          onClick={() => { actionButtonClicked(action)}}>{action}
          {action === 'Duplicate' ? duplicatePopup : 
            action === 'Delete' ? deletePopup :
              action === 'Unconfirm' ? unconfirmPopup : 
                action === 'Confirm' ? confirmPopup : null}
          </div> 
        }
          
        )}
      </div>
  }

  const driversDetailsPopup = showDriversDetails && <div className={`${styles.driversDetailsPopup}`}>
    {console.log("checklistDriversInfo.checklistTemplateQuantitativeDrivers: ", checklistDriversInfo?.checklistTemplateQuantitativeDrivers)}

    <table className={`table table-striped ${styles.driversDetailsTable} m-0`}>
      <thead>
        <tr>
          <th colSpan={2}>Checklist {visibleDriversChecklistId}</th>
          {/* <th>{visibleDriversChecklistId}</th> */}
        </tr>
        <tr>
          <th className="bg-secondary">MODULO</th>
          <th className="bg-secondary">PESO</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Qualitative</td>
          <td>{checklistDriversInfo?.qualitativeWeight}</td>
        </tr>
        <tr>
          <td>Quantitative</td>
          <td>{checklistDriversInfo?.quantitativeWeight}</td>
        </tr>
        {checklistDriversInfo?.checklistTemplateQuantitativeDrivers?.map((driver, index) => {
          return (
            <tr key={driver.id}>
              <td>KPI {index + 1}</td>
              <td>{driver.weight}</td>
            </tr>
          )
        })}
        <tr>
          <td>Coverage</td>
          <td>{checklistDriversInfo?.coverage}</td>
        </tr>
        <tr>
          <td>Accuracy</td>
          <td>{checklistDriversInfo?.accuracy}</td>
        </tr>
      </tbody>
    </table>
  </div>

  return (
    <div className={`${styles.checklistMonitor} outerContainer`}>
      <div className={`${styles.toolbar} d-flex justify-content-between`}>
        <div className="d-flex align-items-center justify-content-left">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          <button className={styles.clearFiltersButton} onClick={clearGlobarFiltersHandler}>Clear filters</button>
        </div>
        {!showButtons && <p className={`${styles.instructions} ${styles.generic}`}>Select a checklist by clicking on a table row</p>}
        {!showButtons && <div className={styles.helperDiv}></div> /* helper div */}
        {/* {showButtons && selectedRecordIsFrozen && <p className={`${styles.instructions} ${styles.frozen}`}>Frozen</p>} */}
        <GenericModal
          show={modalShow}
          handleClose={genericModalCloseHandler}
          action={modalAction}
          title={modalTitle}
          message={modalMessage}
          modalType={modalType}
        />
        {showButtons && buttons}
      </div>
      {driversDetailsPopup}
      {!isLoading && <table {...getTableProps()} className={styles.tableStyle}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // <th {...column.getHeaderProps()}>
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <div className="h-100 position-relative">
                    <div className="" >
                      {column.render("Header")}
                      &nbsp;
                      <div className={column.isSorted ? (column.isSortedDesc ? styles.descOrder : styles.ascOrder) : ' '}></div>
                    </div>
                    {column.canFilter ? <div style={{height: "15px"}}></div> : ""}
                    <div className={`${styles.filter} position-absolute bottom-0`} style={{left: "10%"}}>{column.canFilter ? column.render('Filter') : null}</div>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            let rowId = row.cells.filter(cell => cell.column.id === "id")[0].value;
            return (
              <tr {...row.getRowProps()} 
                onClick={() => {
                  // console.log("show cells: ", row.cells)
                  showButtonsHandler(row.cells, row)
                }}
                // onMouseEnter={(e) => {
                //   showDriversDetailsButton(e, rowId);
                //   // showInfoIcon(e);
                // }}
                // onMouseLeave={(e) => {
                //   hideDriversDetailsButton(e, rowId);
                //   // hideInfoIcon(e);
                // }} 
                className={`${showButtons && selectedRecordId === rowId ? `${styles.active} ${isSuperuser && selectedRecordIsFrozen && styles.frozen}` : ""}`}>
                {row.cells.map((cell, index) => (
                  <td {...cell.getCellProps()} className={"text-center"}>
                      {/* {(cell.column.id === 'id') && (
                        <button 
                          className={`${styles.driverDetailsButton} ${(rowEnteredByMouse === rowId && driversDetailsButtonIsVisible) ? 'visible' : 'invisible'}`}
                          onClick={() => getChecklistDriversHandler(rowId)}>
                      
                        View drivers Info</button>
                      )} */}
                      {/* {console.log("cell cell:", cell)} */}
                      {cell.column.Header !== "Visible on BI" ? 
                        cell.render("Cell") :
                        cell.render(<Checkbox value={cell.value === "Yes" ? true : false} column={cell.column} disabled={row.original.frozen} elementId={rowId} performAction={updateVisibleOnBiHandler} />)
                      }
                    </td>
                    // <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>}
      {isLoading && <Loading />}
    </div>
  );
};

export default ChecklistMonitor;

